export default "__VITE_ASSET__CfRe3pPx__"